import { styled } from '@mui/material/styles';
import { alpha, lighten } from '@mui/material/styles';
import { Box, Button, DialogContent } from '@mui/material';

export const TitleArea = styled('div')({
  justifyContent: 'center',
});

export const LeftIcon = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

export const TitleContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  height: '100%',
  overflowY: 'auto',
  // Override MUI DialogContent's default 20px/24px so this matches other modals.
  padding: theme.spacing(2),
}));

export const DateRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const RatingRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
});

export const Col = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ isMobile }) => ({
  display: 'flex',
  flexDirection: isMobile ? 'row' : 'column',
  flex: '1 1 auto',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
}));

export const RatingWrap = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ isMobile }) => ({
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  width: '100%',
}));

export const ColMobile = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  height: '100%',
  width: 100,
  maxWidth: 20,
  minHeight: 30,
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
});

export const TextCol = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
}));

export const TextSmall = styled('div')({
  fontSize: 12,
});

export const CpRow = styled('div')({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  pageBreakInside: 'avoid !important',
});

export const CpName = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  width: isMobile ? 100 : `calc(160px - ${theme.spacing(2)})`,
  minWidth: isMobile ? 100 : `calc(160px - ${theme.spacing(2)})`,
  fontWeight: 600,
  fontSize: 12,
  display: 'flex',
  flexDirection: 'column',
}));

export const Cp0 = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.action.disabledBackground,
}));

export const HlRow = styled('div')(({ theme }) => ({
  backgroundColor: alpha(theme.palette.error.main, 0.15),
}));


export const TranslationContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(0.5),
}));

export const PaddingTop = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(2),
}));

export const IconContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
});

// Backward-compat object for components that destructure `styles.X` (e.g. inputStyles: styles.paddingTop)
export const styleClasses = {
  // these were originally CSS classnames; preserve a couple of legacy slots that consumers reference by name
  paddingTop: undefined,
};
